
import { defineComponent } from "vue"
import CardsManagementIndex from "@/components/cards_management/Index.vue"

export default defineComponent({
  components: {
    CardsManagementIndex
  }
})
